import type { OAuthProviderType } from '../contracts/SharedProperties';
import getIdpConfig from '../identityProvider/getIdpConfig';
import { parse as parseUrl } from 'url';

export default function isProviderHostAvailable(
    provider: OAuthProviderType,
    clientId: string
): Promise<boolean> {
    const fullUrl = parseUrl(getIdpConfig(provider, clientId)[provider].oauth.auth);
    const providerHostUrl = fullUrl.protocol + '//' + fullUrl.host;

    return isUrlAvailable(providerHostUrl);
}

async function isUrlAvailable(uri: string): Promise<boolean> {
    let isAvailable = false;

    await fetch(uri, { method: 'GET', mode: 'no-cors' })
        .then(() => {
            isAvailable = true;
        })
        .catch(e => {
            // Ignore
        });

    return isAvailable;
}
